import { render, staticRenderFns } from "./MyPageUser.vue?vue&type=template&id=30567d97&"
import script from "./MyPageUser.vue?vue&type=script&lang=js&"
export * from "./MyPageUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports